import { render, staticRenderFns } from "./tel-waiting-collect-case-manage.vue?vue&type=template&id=1731f3ca&scoped=true"
import script from "./tel-waiting-collect-case-manage.vue?vue&type=script&lang=ts"
export * from "./tel-waiting-collect-case-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1731f3ca",
  null
  
)

export default component.exports